var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_19249",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 19249",
    transform: "translate(-555 -548)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_18173",
    "data-name": "\\u9577\\u65B9\\u5F62 18173",
    width: 25,
    height: 25,
    transform: "translate(555 548)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(556.159 548.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25080",
    "data-name": "\\u30D1\\u30B9 25080",
    d: "M5.325,6.452A.825.825,0,0,1,4.5,5.627v-3.3a.825.825,0,0,1,1.651,0v3.3A.825.825,0,0,1,5.325,6.452Zm9.9,0a.825.825,0,0,1-.825-.825v-3.3a.825.825,0,0,1,1.651,0v3.3A.825.825,0,0,1,15.229,6.452Z",
    transform: "translate(0.453 -1.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25081",
    "data-name": "\\u30D1\\u30B9 25081",
    d: "M20.482,22.308H3.976A2.479,2.479,0,0,1,1.5,19.832V4.976A2.479,2.479,0,0,1,3.976,2.5H20.482a2.479,2.479,0,0,1,2.476,2.476V19.832A2.479,2.479,0,0,1,20.482,22.308ZM3.976,4.151a.825.825,0,0,0-.825.825V19.832a.825.825,0,0,0,.825.825H20.482a.825.825,0,0,0,.825-.825V4.976a.825.825,0,0,0-.825-.825Z",
    transform: "translate(-1.499 -0.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_25082",
    "data-name": "\\u30D1\\u30B9 25082",
    d: "M22.133,7.151H2.325a.825.825,0,1,1,0-1.651H22.133a.825.825,0,0,1,0,1.651ZM8.1,8.8H9.753v1.651H8.1Zm3.3,0h1.651v1.651H11.4Zm3.3,0h1.651v1.651H14.705Zm3.3,0h1.651v1.651H18.006ZM4.8,12.1H6.452v1.651H4.8Zm3.3,0H9.753v1.651H8.1Zm3.3,0h1.651v1.651H11.4Zm3.3,0h1.651v1.651H14.705Zm3.3,0h1.651v1.651H18.006ZM4.8,15.4H6.452v1.651H4.8Zm3.3,0H9.753v1.651H8.1Zm3.3,0h1.651v1.651H11.4Z",
    transform: "translate(-1.499 1.103)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleIcon2);
export default __webpack_public_path__ + "static/media/scheduleIcon2.de30e96e6e7ffc4639ed73977ac54ba0.svg";
export { ForwardRef as ReactComponent };